import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/notifications";

export const notificationsApi = {
  list: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}?${searchParams.toString()}`);
  },

  getById: (id: string) => apiGet<{ notification: Record<string, unknown> }>(`${BASE}/${id}`),

  markAsRead: (id: string) => apiPost<{ notification: Record<string, unknown> }>(`${BASE}/${id}/read`),

  markAllAsRead: () => apiPost<{ message: string }>(`${BASE}/read-all`),

  delete: (id: string) => apiDelete<{ message: string }>(`${BASE}/${id}`),

  clearAll: () => apiDelete<{ message: string }>(`${BASE}`),

  getPreferences: () => apiGet<{ preferences: Record<string, unknown> }>(`${BASE}/preferences`),

  updatePreferences: (data: Record<string, unknown>) =>
    apiPut<{ preferences: Record<string, unknown> }>(`${BASE}/preferences`, data),
};
